import styled from 'styled-components'
import Icon from '@material-ui/core/Icon'

export const StyledStartIcon = styled(Icon)`
	margin-right: 0.5rem;
`

export const StyledEndIcon = styled(Icon)`
	margin-left: 0.5rem;
`
